function initSwiperSlider() {
  (function pollForSwiper() {
    if (window.Swiper !== undefined) {
      var swiper = new Swiper(".shopSwiper", {
          navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
          },
          spaceBetween: 15,
          breakpoints: {
              300: {
                  slidesPerView: 4.36,
              },
              1024: {
                  slidesPerView: 10.6,
              },
              1200: {
                  slidesPerView: 11.5,
              },
              1400: {
                  slidesPerView: 11.8,
              },
          },
      });
    } else {
      setTimeout(pollForSwiper, 25);
    }
  })()
}

document.addEventListener("DOMContentLoaded", (event) => {
  initSwiperSlider();
});